/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSalesManager.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/sales-manager";

export class AutogenModelSalesManager<RowType extends ModelRow> extends Endpoint<RowType, RowSalesManagerFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSalesManager extends ModelRow<RowSalesManagerFields> {
	constructor(values?: Partial<RowSalesManagerFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSalesManagerFields {
	address: string;
	city: string;
	commission_payee_id: string;
	company_id: string;
	id: string;
	is_manager: string;
	name: string;
	percentage: number;
	sales_manager_id: string;
	state: string;
	user_id: string;
	zip_code: string;
}

